/**
 * @功能名称: 微信分享
 * @params:  ShareData,config
 * shareData={
 *   title:'',
 *   shareUrl:'',
 *   picUrl:'',
 *   content:'',
 *   success: function () {}, // 成功回调
 *   cancel:  function () {}  // 失败回调
 * }
 * config = {
 *  getConfigUrl: ''
 * }
 * @文件名称: wxShare
 * @Date: 2019/1/2 下午18:23.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import { postSlient } from '../network/http'
import lazyLoad from '../helper/lazyLoad'
import browsersInfo from '../helper/ySniff'
import { clone } from '../helper/utils'

var browsers = browsersInfo.browsers
var config = {
  getConfigUrl: '/h5/common/wx_js_sdk'
};
//  微信配置
var set = {
  debug: false
}
var loadJSSDK = ''
if (browsers.wechat) {
  loadJSSDK = lazyLoad('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')
}

function getConfig() {
  var url = decodeURIComponent(location.href.split('#')[0]);
  return postSlient(config.getConfigUrl, { h5url: url })
}

// 微信分享初始化，加载sdk， 获取配置数据
function wxShare(data, opt, setting) {
  if (!browsers.wechat) {
    return false;
  }
  config = Object.assign(config, opt) // 覆盖默认配置项
  set = setting;
  return Promise.all([loadJSSDK, getConfig()]).then(([, json]) => {
    refreshConfig(json.data, data)
  })
}



function refreshConfig(data, shareData) {
  if (!window.wx || !data || !data.appId || !data.timestamp || !data.nonceStr || !data.signature) return;
  var config = Object.assign({
    debug: false,
    appId: '', // 必填，公众号的唯一标识
    timestamp: '', // 必填，生成签名的时间戳
    nonceStr: '', // 必填，生成签名的随机串
    signature: '',
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
    openTagList: ['wx-open-launch-weapp']
  }, data, set)
  wx.config(clone(config));
  var wxShareData = {
    title: shareData.title,
    desc: shareData.content,
    link: shareData.shareUrl,
    imgUrl: shareData.picUrl,
    success: shareData.success || function () { },
  }

  wx.ready(function () {
    wx.updateAppMessageShareData(wxShareData)
    // config.jsApiList.forEach(item=>{
    //   if(item === 'onMenuShareAppMessage'){
    //     wx[item](Object.assign({type:'link'},wxShareData))
    //   }else {
    //     console.log(222,wxShareData)
    //     wx[item](wxShareData)
    //   }
    // })
  });
  wx.error((e) => {
    console.log(e, 'hhh')
  })
}

export default wxShare
